import { FieldProps } from 'formik';
import { InputHTMLAttributes } from 'react';
import { ContentInjectable } from 'modules/af_cm_ui_kit/components/types';
import { SaveData } from 'utils/api/types';
import { Address } from 'components/DetailsPageBoilerplate/types';

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  handleBlur?: (...args: any[]) => void;
  title: string;
  subtitle?: string;
}

interface ChangeableAddress {
  onChangeClick: (fieldName: string) => (values: SaveData) => Promise<any>;
  addressValues: Address;
  setFieldValue: (field: string, value: any) => void;
  prefix?: string;
}

export type Props = ChangeableAddress;

export enum FIELDS {
  POSTCODE = 'postcode',
  HOUSE_NUMBER = 'houseNumber',
  ADDRESS_LINE_1 = 'addressLine1',
  ADDRESS_LINE_2 = 'addressLine2',
  CITY = 'city',
  COUNTY = 'county',
  FULL_ADDRESS = 'fullAddress',
}

export enum FIELDS_LABELS {
  POSTCODE = 'Postcode',
  HOUSE_NUMBER = 'Address Line 1',
  ADDRESS_LINE_1 = 'Address Line 2',
  ADDRESS_LINE_2 = 'Address Line 3',
  CITY = 'City',
  COUNTY = 'County',
  FULL_ADDRESS = 'Address',
}

export type AddressType = {
  [FIELDS.POSTCODE]: string;
  [FIELDS.HOUSE_NUMBER]: string;
  [FIELDS.ADDRESS_LINE_1]?: string;
  [FIELDS.ADDRESS_LINE_2]?: string;
  [FIELDS.CITY]: string;
  [FIELDS.COUNTY]?: string;
};

interface ChangeableTextField {
  onChangeClick: (values: SaveData) => Promise<any>;
  disabledButton?: boolean;
  addressValues: Address;
}

export type FullAddressProps = FieldProps & TextInputProps & ContentInjectable & ChangeableTextField;
